<button
  (click)="onClick($event)"
  class="button {{ className || emptyString }} {{
    notifiaction ? 'notification' : emptyString
  }} "
  [style.--icon-size.px]="iconSize"
  [disabled]="disable">
  <div *ngIf="showCounter" class="button__bubble">{{ counter }}</div>
  <div *ngIf="isLoading" class="button__spinner"></div>
  <img
    *ngIf="icon && !isLoading"
    src="{{ icon }}"
    alt=""
    srcset=""
    class="button__icon" />{{ titulo
  }}<img
    *ngIf="iconsSave"
    src="{{ iconsSave }}"
    alt=""
    srcset=""
    class="button__iconSave" />
  <img
    *ngIf="iconPlus"
    src="{{ iconPlus }}"
    alt=""
    srcset=""
    class="button__iconSave" />
</button>
